export default {
  title: 'Solicitări de ștergere date',
  fields: {
    created_at: 'Solicitat la',
    restaurant: 'Restaurant',
    customer: 'Client',
    note: 'Notă',
    status: 'Stare',
    completed_by: 'Finalizat de',
    actions: 'Acțiuni',
  },
  statuses: {
    pending: 'În așteptare',
    completed: 'Finalizat',
  },
  buttons: {
    approve: 'Aprobă',
  },
  modals: {
    approve: {
      title: 'Aprobați ștergerea datelor pentru {{name}}?',
      description:
        'Aceasta șterge definitiv datele personale ale clientului și nu poate fi anulată. Solicitarea va fi marcată ca finalizată.',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_approve: 'Eroare la aprobarea solicitării',
    approved: 'Solicitare aprobată și date șterse',
  },
};
